// Should stay in sync with the checkpoint-performance-report-metric-enums.mjs
export const QUALITY_DOMAINS = {
  Safety: {
    Id: 1,
    Value: 'Safety',
    Description:
      'Device does not compromise the clinical condition or the safety of patients, or the safety and health of users.'
  },
  Effectiveness: {
    Id: 2,
    Value: 'Effectiveness',
    Description:
      'Device produces the effect intended by the manufacturer relative to the medical condition(s).'
  },
  Reliability: {
    Id: 3,
    Value: 'Reliability',
    Description:
      'Device system or component is able to function under stated conditions for a specified period of time.'
  },
  PatientSatisfaction: {
    Id: 4,
    Value: 'Patient Satisfaction',
    Description:
      'Device was perceived to meet or exceed patient expectations of usability and outcome.'
  },
  Usability: {
    Id: 5,
    Value: 'Usability',
    Description: 'Device minimizes the risk of user errors by patients or clinicians.'
  },
  Availability: {
    Id: 6,
    Value: 'Availability',
    Description: 'Device is available to fill first request orders.'
  },
  Compatibility: {
    Id: 7,
    Value: 'Compatibility',
    Description:
      'Device is compatible with related devices or drugs, the use environment or relevant standards.'
  },
  NA: {
    Id: 8,
    Value: 'N/A',
    Description: 'Please describe value-add / reason for metric submission.'
  }
};

export const GOOD_PERFORMANCE_INDICATORS = {
  Increases: {
    Id: 1,
    Value: '# Increases'
  },
  Decreases: {
    Id: 2,
    Value: '# Decreases'
  },
  StaysInSpecifiedRange: {
    Id: 3,
    Value: '# Stays in specified range'
  },
  ApproachesTarget: {
    Id: 4,
    Value: '# Approaches Target'
  }
};

export const MEASUREMENT_CALCULATIONS = {
  TotalCount: {
    Id: 1,
    Value: 'Total Count'
  },
  Percentage: {
    Id: 2,
    Value: 'Percentage'
  },
  Rate: {
    Id: 3,
    Value: 'Rate'
  },
  Ratio: {
    Id: 4,
    Value: 'Ratio'
  }
};

export const MEASUREMENT_LEVELS = {
  SpecificProduct: {
    Id: 1,
    Value: 'Specific Product'
  },
  SpecificProductFamily: {
    Id: 2,
    Value: 'Specific Product Family'
  },
  AllProductsAtTheFacility: {
    Id: 3,
    Value: 'All Products at the Facility'
  },
  AllProductsAtAllFacilities: {
    Id: 4,
    Value: 'All Products at all Facilities'
  },
  SubsetOfProductsAtFacility: {
    Id: 5,
    Value: 'Subset of Products at Facility'
  }
};

export const PERFORMANCE_METRIC_STATUSES = {
  Update: {
    Id: 1,
    Value: 'Update'
  },
  Skip: {
    Id: 2,
    Value: 'Skip'
  },
  NA: {
    Id: 3,
    Value: 'N/A'
  },
  Discontinue: {
    Id: 4,
    Value: 'Discontinue'
  }
};

export const TIME_BOUNDS = {
  AllTime: {
    Id: 1,
    Value: 'All Time'
  },
  PeriodOfTime: {
    Id: 2,
    Value: 'Period of Time'
  },
  RollingTime: {
    Id: 3,
    Value: 'Rolling Time'
  }
};

export const TIME_FRAMES = {
  Daily: {
    Id: 1,
    Value: 'Daily'
  },
  Weekly: {
    Id: 2,
    Value: 'Weekly'
  },
  BiWeekly: {
    Id: 3,
    Value: 'Bi-Weekly'
  },
  Monthly: {
    Id: 4,
    Value: 'Monthly'
  },
  Quarterly: {
    Id: 5,
    Value: 'Quarterly'
  },
  SemiAnnually: {
    Id: 6,
    Value: 'Semi-Annually'
  },
  Annually: {
    Id: 7,
    Value: 'Annually'
  }
};
